import React from 'react';
import OnboardingNav from './OnboardingNav';
import OnboardingProvider from './OnboardingProvider';
import OnboardingSteps from './OnboardingSteps';
import OnboardingStep from './OnboardingStep';
import { chefAPI } from '../../InterfaceAPI/chefAPI';
import { breakpoints } from '../../const';
import OnboardingSubmitContainer from './OnboardingSubmitContainer';
import OnboardingSubmitDefault from './OnboardingSubmitDefault';
import ChefLocations from './chef/ChefLocations';
import ChefLocationsNav from './chef/ChefLocationsNav';
import ChefAvailability from './chef/ChefAvailability';
import ChefAvailabilityNav from './chef/ChefAvailabilityNav';
import ChefDetails from './chef/ChefDetails';
import OnboardingSubmitSkip from './OnboardingSubmitSkip';
import withUser from '../auth/withUser';
import { stringfyServerErrors } from '../../helpers/util';
import withSplashMessage from '../splashMessage/withSplashMessage';
import withTracker from '../withTracker';

class ChefOnboarding extends React.Component {
  state = {
    chef: {},
    progress: [],
    resets: [],
    isMobile: false
  };

  render() {
    return (
      <OnboardingProvider className="cms" onboardingType="chef">
        <div className="cms__content cms__content--full">
          {this.state.isMobile
            ? this.renderMobileLayout()
            : this.renderDesktopLayout()}
        </div>
      </OnboardingProvider>
    );
  }

  renderDesktopLayout() {
    const { isMobile } = this.state;

    return (
      <div className="on-boarding on-boarding--chef">
        {this.renderMain()}
        <div className="on-boarding__right">
          <OnboardingNav isMobile={isMobile} subject={this.state.chef} />
          <OnboardingSubmitContainer />
        </div>
      </div>
    );
  }

  renderMobileLayout() {
    const { isMobile } = this.state;
    return (
      <div className="on-boarding on-boarding--chef">
        <OnboardingNav isMobile={isMobile} subject={this.state.chef} />
        {this.renderMain()}
        <OnboardingSubmitContainer />
      </div>
    );
  }

  renderMain() {
    const { chef } = this.state;
    return (
      <div className="on-boarding__main">
        <OnboardingSteps>
          <OnboardingStep
            step={0}
            resets={[]}
            path={`${this.props.match.url}`}
            navLabel="Preferred Locations"
            navComponent={ChefLocationsNav}
            mainComponent={ChefLocations}
            mainProps={{ chef, updateChef: this.updateChef }}
            submitComponent={OnboardingSubmitDefault}
            submitProps={{
              disabledCopy: 'Select Locations',
              enabledCopy: 'Continue'
            }}
          />

          <OnboardingStep
            step={1}
            resets={[]}
            path={`${this.props.match.url}/step-2`}
            navLabel="Weekly Availability"
            navComponent={ChefAvailabilityNav}
            mainComponent={ChefAvailability}
            mainProps={{ chef, updateChef: this.updateChef }}
            submitComponent={OnboardingSubmitSkip}
            submitProps={{
              disabledCopy: 'Select Weekly Availability',
              enabledCopy: 'Continue'
            }}
          />

          <OnboardingStep
            step={2}
            resets={[]}
            path={`${this.props.match.url}/step-3`}
            navLabel="Account Details"
            mainComponent={ChefDetails}
            mainProps={{
              chef,
              updateChef: this.updateChef,
              postSignup: this.postSignup
            }}
            submitComponent={OnboardingSubmitDefault}
            submitProps={{
              disabledCopy: 'Add Account Info',
              enabledCopy: 'Complete Account Creation'
            }}
          />
        </OnboardingSteps>
      </div>
    );
  }

  // to be called in final step of on boarding
  postSignup = () => {
    const { chef } = this.state;
    chefAPI
      .updateChef(chef)
      .then(data => {
        // console.log(data);
        this.reset();
        this.props.history.push({ pathname: '/new-chef/thank-you' });
      })
      .catch(err =>
        this.props.addMessage({
          className: 'error',
          message: stringfyServerErrors(err)
        })
      );
  };

  getChefPayload = () => {
    const { chef } = this.state;
    // service_district_subsections
    return {
      ...chef,
      // service_district_subsections: chef.service_districts.map(),
      service_districts: []
    };
  };

  updateChef = (updatedChef, cb = () => {}) => {
    // update the chef
    const chef = { ...this.state.chef, ...updatedChef };
    this.setState({ chef }, cb);
  };

  reset = () => {
    localStorage.removeItem('chef-on-boarding');
    this.setState({ chef: {} });
    this.props.history.push({ pathname: this.props.match.url });
  };

  componentWillMount() {
    let state = {};

    // load from local storage
    const localStorageRef = localStorage.getItem(`chef-on-boarding`);
    if (localStorageRef) {
      state = { ...JSON.parse(localStorageRef) };
    }

    state.chef = {
      ...state.chef,
      id: this.props.user.id,
      email: this.props.user.email
    };

    this.setState(state);
  }

  componentWillUpdate(nextProps, nextState) {
    // don't store these ever
    const safeSpace = {
      password: '',
      password_confirmation: ''
    };
    // save to local storage
    localStorage.setItem(
      `chef-on-boarding`,
      JSON.stringify({ chef: { ...nextState.chef, ...safeSpace } })
    );
  }

  componentWillReceiveProps(nextProps, prevState) {
    const isMobile = nextProps.windowWidth < breakpoints.tablet;
    if (this.state.isMobile !== isMobile) this.setState({ isMobile });
  }
}

export default withUser(withSplashMessage(withTracker(ChefOnboarding)));



// WEBPACK FOOTER //
// ./src/components/onboarding/ChefOnboarding.js